// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
import ReactSelectService from 'app_services/components/reactSelectService'
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { IPortfolioProgramQuery } from 'app_types/admin/portfolioProgram/portfolioProgram.types'
// @end

// @import types
// @end

export class PortfolioProgramService{

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil
  private reactSelectService: ReactSelectService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
    this.reactSelectService = new ReactSelectService()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  async list(params: IPortfolioProgramQuery) {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/portfolio-program`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }


}
